import { render, staticRenderFns } from "./TrackedProductsList.vue?vue&type=template&id=a5f98d2e&scoped=true&"
import script from "./TrackedProductsList.vue?vue&type=script&lang=js&"
export * from "./TrackedProductsList.vue?vue&type=script&lang=js&"
import style0 from "./TrackedProductsList.vue?vue&type=style&index=0&id=a5f98d2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f98d2e",
  null
  
)

export default component.exports